export enum BluebillywigPlayerStateEnum {
  Playing = 'playing',
  Paused = 'paused',
  Idle = 'idle',
  Loading = 'loading',
}

export enum BlueBillywigPlayerStateIconsEnum {
  playing = 'pause',
  paused = 'play',
  loading = 'play', // eslint-disable-line
  idle = 'rotate-left',
}

export type BluebillywigPlayerState =
  | BluebillywigPlayerStateEnum.Playing
  | BluebillywigPlayerStateEnum.Paused
  | BluebillywigPlayerStateEnum.Idle
  | BluebillywigPlayerStateEnum.Loading;

export interface BluebillywigPlayer {
  on(event: string, callback: () => void): void;
  off(event: string): void;
  play(event: string): void;
  pause(event: string): void;
  seek(position: number): void;
  getState(): BluebillywigPlayerState; // https://support.bluebillywig.com/player-api/events-modes-and-phases/#4-0-states
  getDuration(): number;
  destruct(): void;
}

export interface Bluebillywig {
  Player: new (url: string, options: object) => BluebillywigPlayer;
  players: Array<BluebillywigPlayer>;
}

export type BluebillywigAudioType = 'MP3' | 'AAC';

export const BluebillywigAssetMediaType: Record<BluebillywigAudioType, string> =
  {
    MP3: 'audio/mpeg',
    AAC: 'audio/mp4',
  };

export type BluebillywigAssetData = {
  bandwidth: string;
  mediatype: BluebillywigAudioType;
  src: string;
  status: string;
};

export type NativeAudioAsset = {
  source: string;
  type: string | null;
};
